// extracted by mini-css-extract-plugin
export default {"tabs":"style_tabs__PmZeF","tabsHeader":"style_tabsHeader__wdw0-","tabsList":"style_tabsList__eFOea","tab":"style_tab__FS7+9","tabSelected":"style_tabSelected__Cqlas"};